import TitleCell from "../titleCell"

export const titleCell = (params:any) => {
    return <TitleCell value={params.value} />
}